module.exports = __webpack_public_path__ + "img/94.4.NH3-N.f49b1e53.png";